import { type ReactNode } from "react";
import { type VariantProps, cva } from "class-variance-authority";
import { cx } from "class-variance-authority";

import { Caret } from "../Caret/Caret";
import { Drawer } from "../Drawer/Drawer";
import { Info } from "../Icon/Info";

import * as styles from "./InfoPanel.module.scss";

const infoPanelVariants = cva(styles.base, {
  variants: {
    color: {
      info: styles.info,
      promo: styles.promo,
      neutral: styles.neutral,
    },
  },
  defaultVariants: {
    color: "neutral",
  },
});

type InfoPanelProps = React.HTMLAttributes<HTMLElement> & {
  title: ReactNode;
  icon?: ReactNode;
  open: boolean;
  onOpen: (open: boolean) => void;
  showArrow?: boolean;
} & VariantProps<typeof infoPanelVariants>;

const InfoPanel = ({
  title,
  icon,
  open,
  onOpen,
  children,
  color,
  showArrow,
  className,
}: InfoPanelProps) => {
  return (
    <div
      className={cx(
        infoPanelVariants({ color }),
        {
          [styles.showTriangle]: showArrow,
        },
        className,
      )}
    >
      <div onClick={() => onOpen(!open)} className={styles.header}>
        <div className={styles.icon}>{icon ?? <Info />}</div>
        <div className={styles.headingText}>{title}</div>
        <div className={styles.toggleContainer}>
          <Caret variant={open ? "up" : "down"} className={styles.caret} />
        </div>
      </div>
      <Drawer isOpen={open}>
        <div className={styles.content}>{children}</div>
      </Drawer>
    </div>
  );
};

InfoPanel.displayName = "InfoPanel";

export { InfoPanel };
